import { render, staticRenderFns } from "./paragraphModel.vue?vue&type=template&id=5d9228a0&scoped=true"
import script from "./paragraphModel.vue?vue&type=script&lang=js"
export * from "./paragraphModel.vue?vue&type=script&lang=js"
import style0 from "./paragraphModel.vue?vue&type=style&index=0&id=5d9228a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9228a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9228a0')) {
      api.createRecord('5d9228a0', component.options)
    } else {
      api.reload('5d9228a0', component.options)
    }
    module.hot.accept("./paragraphModel.vue?vue&type=template&id=5d9228a0&scoped=true", function () {
      api.rerender('5d9228a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionnaire/customerManage/questionnaireList/components/paragraphModel.vue"
export default component.exports